import * as React from 'react';
export const ProspectInfoRow = ({
    label,
    value,
    includeTopSpacer,
    optional,
    children,
    singleColumn,
    externalLabelStyle
}: {
    label: string;
    value?: string;
    includeTopSpacer?: boolean;
    optional?: boolean;
    children?: React.ReactNode;
    singleColumn?: boolean;
    externalLabelStyle?: any;
}) =>
    optional === true && (value === null || value === undefined || value === '') ? null : (
        <div className="row m-3">
            <div
                className={
                    'font-weight-bold' +
                    (includeTopSpacer ? ' mt-2' : '') +
                    (singleColumn ? ' col-sm-12' : ' col-sm-5')
                }
                style={externalLabelStyle!=null ?externalLabelStyle:{}}
            >
                {label}
            </div>
            <div className={singleColumn ? 'col-sm-12' : 'col-sm-7'}>{value || children}</div>
        </div>
    );



// WEBPACK FOOTER //
// ./src/components/pages/admin/dashboardWidgets/prospectInfoRow.tsx